import request from "root/js/request";

export const getSocialBloggersCount = async params => {
  const response = await request({
    url: `parsers/social/bloggers/count/`,
    method: "get",
    params: {
      ...params,
      // Для обратной совместимости, где-то может осталась передача item, можно удалить после
      // релиза pages/bloggers_profiles_selection
      subject_id__in: params.subject_id__in || params.item__in,
    },
  });
  return response;
};
